/**
 * Cross-slice cache invalidation bridge: when a `notificationRulesApi`
 * send-test mutation fulfills, also invalidate `'Notification'` on
 * `notificationsApi` so any notifications surface currently rendering
 * refetches. Mirrors `rca-notifications-bridge.ts`.
 */

import { createListenerMiddleware } from '@reduxjs/toolkit'

import { notificationsApi } from '../notifications'
import { notificationRulesApi } from './notification-rules-api'

export const notificationRulesNotificationsBridge = createListenerMiddleware()

notificationRulesNotificationsBridge.startListening({
  matcher: notificationRulesApi.endpoints.sendTestNotificationRule.matchFulfilled,
  effect: (_action, api) => {
    api.dispatch(notificationsApi.util.invalidateTags([{ type: 'Notification', id: 'LIST' }]))
  }
})
